<template>
	<li
		class="delivery-time"
		:class="{ unavailable: isUnavailable }"
	>
		<TnIcon
			class="margin-right-s icon"
			:name="icon"
		/>
		<TnParagraph size="s">{{ text }}</TnParagraph>
	</li>
</template>
<script>
export default defineNuxtComponent({
	name: "DeliveryTime",
	props: ["deliveryTime", "isUnavailable"],

	computed: {
		icon() {
			return this.isUnavailable ? this.deliveryTime.outOfStock.overrideIcon : this.deliveryTime.inStock.overrideIcon;
		},
		text() {
			return this.isUnavailable ? this.deliveryTime.outOfStock.overrideText : this.deliveryTime.inStock.overrideText;
		},
	},
});
</script>
<style lang="scss" scoped>
.delivery-time {
	display: flex;
}

.icon {
	position: relative;
	top: -2px;
}

.unavailable {
	color: $color-neutrals-600-shade;
}

:deep(p) {
	color: #333 !important;
}
</style>
